module.exports = __webpack_public_path__ + "static/Integrated-Solar-Street-Light-cce0eb984e87c74a2a10e32f00e9687a.jpg";